// outbrain/client.js
import $ from 'jquery';
import radio from 'radio';
import {
  RESIZE,
  OUTBRAIN,
  OUTBRAIN_REFRESH,
  OUTBRAIN_ENDSLATE_RENDER,
  OUTBRAIN_ENDSLATE_DESTROY,
} from 'shared/enums/events';

radio(OUTBRAIN).subscribe(() => {
  const outbrain = window.OBR;
  if (outbrain && outbrain.extern) {
    outbrain.extern.researchWidget();
  }
});

radio(OUTBRAIN_REFRESH).subscribe(() => {
  if ($('.component.outbrain .OUTBRAIN').length > 0) {
    const outbrain = window.OBR;
    if (outbrain && outbrain.extern) {
      outbrain.extern.refreshWidget();
    }
  }
});

const render = function render() {
  return $('.LAZYBRAIN:not(.ENDSLATE)').each((i, elem) => {
    const $this = $(elem);
    if ($this.is(':visible')) {
      $this.clone().removeClass('LAZYBRAIN').addClass('OUTBRAIN').insertAfter($this);
      $this.remove();
      radio(OUTBRAIN).broadcast();
    }
  });
};

radio(OUTBRAIN_ENDSLATE_RENDER).subscribe(() => {
  $('.LAZYBRAIN.ENDSLATE').each((i, elem) => {
    $(elem).removeClass('ENDSLATE');
    render();
  });
});

radio(OUTBRAIN_ENDSLATE_DESTROY).subscribe(() => {
  $('.component.outbrain.end-slate').each(() => {
    const $this = $(this);
    const $widget = $this.find('.OUTBRAIN').eq(0);
    if ($widget.length === 0) {
      return;
    }
    const data = $widget.data();
    $this.empty();
    $(document.createElement('div')).addClass('LAZYBRAIN ENDSLATE').attr({
      'data-src': data.src,
      'data-widget-id': data.widgetId,
      'data-ob-template': data.obTemplate,
    }).appendTo($this);
  });
});

export default function () {
  if (!$('body').hasClass('strip-ads')) {
    return $.getScript('//widgets.outbrain.com/outbrain.js', () => {
      radio(OUTBRAIN).broadcast();
      radio(RESIZE).subscribe(render);
      return render();
    });
  }
  return true;
}



// WEBPACK FOOTER //
// ./~/unicorn/shared/components/outbrain/client.js